import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { GlowPoint } from '@/features/new-landing-page/components/gradient-glow-container';
import { useDetachedState } from '@/components/hooks/use-detached-state';

export interface AppTileGlowPointProps {
  enabled?: boolean;
  children?: React.ReactNode;
}

export function AppTileGlowPoint({ children, enabled }: AppTileGlowPointProps) {
  const [, setTop, topRef] = useDetachedState(`100%`);
  const [, setLeft, leftRef] = useDetachedState(`0%`);
  const [isHovering, setIsHovering] = React.useState(false);

  const handler = useCallback(() => {
    if (isHovering) {
      setTop(`${Math.floor(Math.random() * 100)}%`);
      setLeft(`${Math.floor(Math.random() * 100)}%`);
    } else {
      setTop(`100%`);
      setLeft(`0%`);
    }
  }, [isHovering]);

  useEffect(() => {
    const timer = setInterval(handler, 500);
    return () => clearInterval(timer);
  }, [isHovering]);

  return (
    <>
      {enabled && (
        <GlowPointWrapper
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          {children}
          <GlowPoint
            color="rgb(245,211,243)"
            blur="1rem"
            spread={!isHovering ? `3rem` : `1.5rem`}
            duration={4}
            top={topRef.current}
            left={leftRef.current}
            zIndex={2}
            paused={!isHovering}
            disableGrow
          />
        </GlowPointWrapper>
      )}
      {!enabled && children}
    </>
  );
}

const GlowPointWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  border-top-left-radius: 1.8rem;
  border-bottom-left-radius: 1.8rem;
`;
